import { render, staticRenderFns } from "./AddEditFinalExamAdmin.vue?vue&type=template&id=a0f2780c"
import script from "./AddEditFinalExamAdmin.vue?vue&type=script&lang=js"
export * from "./AddEditFinalExamAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports